// StartDate da ordem é DATA, não instante: a function grava meia-noite UTC
// (2027-01-10 00:00Z), que no fuso de Brasília aparece como o dia anterior. O dia
// certo é o dia UTC — mesma regra do asDateOnly da api.
export function dateOnly(iso) {
  if (!iso) return null;
  const date = new Date(iso);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12);
}
